import { configurationContainer } from "@/configurationContainer";
import { checkIfThisIsE2ETestsEnvironment } from "@/ui/setupE2ETestsDependencies";

// The free-form environment label, used for analytics / observability tags and
// display only. Do NOT branch business logic on this value — use the boolean
// capability helpers below (backed by runtime config) instead of comparing
// against hard-coded environment names.
export const getEnvironment = (): string =>
    configurationContainer.PUBLIC_ENVIRONMENT;

// True only for production environments.
export const isProductionEnvironment = (): boolean =>
    configurationContainer.PUBLIC_IS_PRODUCTION;

// Whether third-party tools (Datadog RUM, Userpilot, Zendesk, in-app help)
// should be active. Enabled in deployed environments via runtime config and
// always disabled under automated (webdriver) test runs.
export const areThirdPartyToolsEnabled = (): boolean =>
    configurationContainer.PUBLIC_THIRD_PARTY_TOOLS_ENABLED &&
    !checkIfThisIsE2ETestsEnvironment();
